//
//
//
//
//

import index from './index';
export default {
  name: 'InfoEnterprise',
  components: {
    index: index
  }
};